import React, {Component} from 'react';
import Modal from '../../../features/shared/containers/Modal';
import TextInput from '../../shared/components/forms/TextInput';
import {connect} from 'react-redux';
import {PHILIPPINE_REGIONS} from '../../../utils/philippineRegions'
import {closeModal} from "../../shared/actions";
import isEmpty from 'is-empty';
import { updateAlert } from '../actions';
import Multiselect from 'multiselect-react-dropdown';
import {isNil} from 'lodash-es'

const multiSelectLabelCss = {
  width: "100%",
  marginBottom: "8px"
}


const multiSelectCss = {
  chips: {
    background: "#5761F0",
    width: "auto",
    wordBreak: "break-word",
    whiteSpace: "unset"
  },
  searchBox: {
    maxWidth: "100%",
    backgroundColor: "#fff",
    border: "solid #8082a9",
    borderRadius: "6px",
    width: "100%",
    marginTop: "2px",
    marginBottom: "4px",
    fontSize: "0.95em",
    fontFamily: "'Lota Grotesque Regular',sans-serif",
    letterSpacing: "-0.028em",
    padding: "12px"
  }
}

class EditAlertModal extends Component{
  constructor(props) {
    super(props)
    this.state = {
      id: "",
      keyword: "",
      regions: "",
      min_amount: "",
      max_amount: "",
      frequency: ""
    }

    this.renderContent = this.renderContent.bind(this);
    this.saveAlert = this.saveAlert.bind(this);
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (!isEmpty(nextProps.id)) {
      let regions = []
      if (isNil(nextProps.filters.regions)) {
        regions = [nextProps.filters.region]
      } else {
        regions = nextProps.filters.regions
      }

      this.setState({
        id: nextProps.id,
        frequency: nextProps.frequency,
        regions: regions,
        ...nextProps.filters
      })
    }
  }

  async saveAlert(event) {
    event.preventDefault();

    const { id, keyword, regions, min_amount, max_amount, frequency } = this.state;

    const payload = {
      frequency: frequency,
      filters: {
        keyword: keyword,
        regions: regions,
        min_amount: min_amount,
        max_amount: max_amount,
      },
    }

    await this.props.updateAlert(id, payload)
  }

  handleAmountKeypress(event) {
    if (["-", "e"].includes(event.key)) {
      event.preventDefault()
    }
  }

  multiSelectOnChange(selectedList) {
    this.setState({regions: selectedList});
  }

  onCloseModal() {
    let regions = []
      if (isNil(this.props.filters.regions)) {
        regions = [this.props.filters.region]
      } else {
        regions = this.props.filters.regions
      }

    this.setState({
      id: this.props.id,
      frequency: this.props.frequency,
      regions: regions,
      ...this.props.filters
    })
  }

  renderContent() {
    return (
      <div className="ds-card">
        <form onSubmit={this.saveAlert}>
          <section className="cardSection">
            <div className='_padding--small'>
              <div className="ds-formGroup _padding--small">
                <TextInput
                  label="Keyword"
                  name="search"
                  value={this.state.keyword}
                  onChange={event => this.setState({keyword: event.target.value})}
                  placeholder="Keyword"
                />
              </div>
              <div className="ds-formGroup _padding--small">
                <label style={multiSelectLabelCss}>
                  <div>
                    <span>Regions</span>
                  </div>
                  <Multiselect
                    isObject={false}
                    options={PHILIPPINE_REGIONS}
                    selectedValues={this.state.regions}
                    onSelect={this.multiSelectOnChange}
                    onRemove={this.multiSelectOnChange}
                    placeholder="Select Regions"
                    avoidHighlightFirstOption={true}
                    style={multiSelectCss}
                  />
                </label>
              </div>
              <div className="ds-formGroup _padding--small">
                <TextInput
                  label="Minimum Amount"
                  name="minimum-amount"
                  value={this.state.min_amount}
                  placeholder="Minimum Amount"
                  type="number"
                  step="any"
                  max={this.state.max_amount}
                  onChange={event => this.setState({min_amount: event.target.value})}
                  onKeyPress={event=> this.handleAmountKeypress(event)}
                />
                <TextInput
                  label="Maximum Amount"
                  name="maximum-amount"
                  value={this.state.max_amount}
                  placeholder="Maximum Amount"
                  type="number"
                  step="any"
                  min={this.state.min_amount}
                  onChange={event => this.setState({max_amount: event.target.value})}
                  onKeyPress={event=> this.handleAmountKeypress(event)}
                />
              </div>
            </div>
            <div className='_padding--small'>
              <div className="text">
                <p className="copy"> How often do you want to be notified? </p>
              </div>
              <div className="ds-formGroup _padding--small">
                <div className="ds-radio">
                  <input
                    type="radio"
                    name="frequency"
                    id="daily"
                    value="daily"
                    required="true"
                    checked={this.state.frequency === "daily"}
                    onClick={(event) => this.setState({frequency: event.target.value})}
                  />
                  <label className="ds-btn" for="daily">Daily</label>
                </div>
                <div className="ds-radio">
                  <input
                    type="radio"
                    name="frequency"
                    id="weekly"
                    value="weekly"
                    required="true"
                    checked={this.state.frequency === "weekly"}
                    onClick={(event) => this.setState({frequency: event.target.value})}
                  />
                  <label className="ds-btn" for="weekly">Weekly</label>
                </div>
              </div>
            </div>
          </section>
          <section className="cardSection _navigation">
            <div class="_right">
              <button className="ds-btn" type="submit">Update Alert</button>
            </div>
          </section>
        </form>
      </div>
    );
  }

  render() {
    return (
      <Modal
        name="editAlertModal"
        open={this.props.showModal}
        title="Edit Project Alert"
        modalClassName='--full'
        gridClassName='--narrow'
        cardClassName='_tight'
        onCloseModal={this.onCloseModal}
      >
        {this.renderContent()}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    closeModal: () => dispatch(closeModal('editAlertModal')),
    updateAlert: (id, payload) => dispatch(updateAlert(id, payload))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditAlertModal);



// WEBPACK FOOTER //
// ./src/features/alertsManager/components/EditAlertModal.js